import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { useParams } from "react-router-dom";
import { stepOneData } from "../../profile/data";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../reducer/auth/auth";
import { getProfileBasicInfo } from "../../../services/admin";
import { updatePricing, updateGroupPricing } from "../../../services/profile";
import { toast } from "react-toastify";
import "./profile.css";

export default function CustomAccordion() {
  const [open, setOpen] = useState(null);
   const dispatch = useDispatch();
  const [profileSection, setProfileSection] = useState(null);
   const [profileLoaded, setProfileLoaded] = useState(false);
  const toggle = (id) => setOpen(open === id ? null : id);
    const { id: pricingId } = useParams(); 
   useEffect(() => {
           getProfile(pricingId);
      }, []);
      
 const getProfile = (id) => {
        dispatch(setLoading(true))
        getProfileBasicInfo(id)
            .then((data) => {
                dispatch(setLoading(false))
                if (data.data.status) {
                    const {
                        country,
                        first_name,
                        last_name,
                        info,
                        languages,
                        mediumship_level_medium, //which users select
                        mediumship_level, //aprroved
                        phone,
                        specialities,
                        website,
                        whatsapp,
                        timezone,
                        when_do_i_pay,
                        session_length,
                        session_currency,
                        profile_image,
                        encoded_image,
                        zoom,
                        google,
                        medium_professional_category,
                        recommendation,
                        encrypted_id,
                        personal_booking_link,
                        is_square_integrated,
                        is_stripe_integrated,
                        is_paypal_integrated,
                        test_mode,
                        extra_services,
                        extra_services_data,
                        extra_services_list,
                        coaching_pricing,
                        hosting_circle_pricing,
                        hosting_qa_pricing,
                        comments,
                        payitforward_pricing,
                        payitforward_coaching_pricing,
                        coaching_info,
                        group_coaching,
                        coached_practice_circles,
                        speaker_events,
                        demo_practice,
                        pay_forward,
                        demo_professional
                    } = data.data.data;
                    console.log(data.data.data,"a");
                    stepOneData.test_mode = test_mode
                    stepOneData.is_square_integrated = is_square_integrated !== undefined && is_square_integrated ? true : false
                    stepOneData.is_stripe_integrated = is_stripe_integrated !== undefined && is_stripe_integrated ? true : false
                    stepOneData.is_paypal_integrated = is_paypal_integrated !== undefined && is_paypal_integrated ? true : false
                    stepOneData.personal_booking_link = personal_booking_link;
                    stepOneData.encrypted_id = encrypted_id;
                    stepOneData.zoom = zoom !== null ? zoom : "";
                    stepOneData.google = google !== null ? google : "";
                    stepOneData.profile_image =
                        profile_image !== "" ? profile_image : null;
                    stepOneData.encoded_image = encoded_image;
                    stepOneData.firstName = first_name;
                    stepOneData.lastName = last_name;
                    stepOneData.website = website;
                    stepOneData.country = country;
                    stepOneData.biographicalInfo = info;
                    stepOneData.phone = phone;
                    stepOneData.mediumshipLevel = parseInt(mediumship_level_medium);
                    stepOneData.mediumship_level = parseInt(mediumship_level);

                    stepOneData.recommendation =
                        recommendation !== null ? recommendation : "";

                    stepOneData.medium_professional_category = medium_professional_category;
                    stepOneData.whatsapp = whatsapp;
                    stepOneData.when_do_i_pay =
                        when_do_i_pay !== undefined
                            ? when_do_i_pay.map((item) => {
                                return String(item);
                            })
                            : [];
                    stepOneData.session_currency =
                        session_currency !== null
                            ? Object.values(JSON.parse(session_currency))[0] !== "" ? Object.values(JSON.parse(session_currency))[0] : "USD"
                            : "USD";
                    stepOneData.session_length_30_currency =
                        session_currency !== null
                            ? Object.values(JSON.parse(session_currency))[0]
                            : "";
                    stepOneData.session_length_45_currency =
                        session_currency !== null
                            ? Object.values(JSON.parse(session_currency))[1]
                            : "";
                    stepOneData.session_length_60_currency =
                        session_currency !== null
                            ? Object.values(JSON.parse(session_currency))[2]
                            : "";
                    stepOneData.session_length_45_2_currency =
                        session_currency !== null
                            ? Object.values(JSON.parse(session_currency))[3]
                            : "";
                    stepOneData.session_length_60_2_currency =
                        session_currency !== null
                            ? Object.values(JSON.parse(session_currency))[4]
                            : "";

                    stepOneData.session_length_30 =
                        session_length !== null
                            ? Object.values(JSON.parse(session_length))[0]
                            : "";

                    stepOneData.session_length_45 =
                        session_length !== null
                            ? Object.values(JSON.parse(session_length))[1]
                            : "";
                    stepOneData.session_length_60 =
                        session_length !== null
                            ? Object.values(JSON.parse(session_length))[2]
                            : "";
                    stepOneData.session_length_45_2 =
                        session_length !== null
                            ? Object.values(JSON.parse(session_length))[3]
                            : "";
                    stepOneData.session_length_60_2 =
                        session_length !== null
                            ? Object.values(JSON.parse(session_length))[4]
                            : "";
                    stepOneData.extra_services = extra_services;
                    stepOneData.extra_services_data = extra_services_data;
                   stepOneData.extra_services_list = extra_services_list !== null ? 
                        extra_services_list.map((item) => {
                          return {
                            id: item.id,
                            amount: item.amount,
                            name: item.sub_session_name,
                          };
                        }) 
                      : "";
                    stepOneData.timezone = { ...timezone, value: timezone.id, label: timezone.front_name };
                    stepOneData.coaching_pricing_30 = coaching_pricing !== null && coaching_pricing !== undefined ? Object.values(JSON.parse(coaching_pricing))[0] : '';
                    stepOneData.coaching_pricing_60 = coaching_pricing !== null && coaching_pricing !== undefined ? Object.values(JSON.parse(coaching_pricing))[1] : '';
                    stepOneData.hosting_circle_pricing_30 = hosting_circle_pricing !== null && hosting_circle_pricing !== undefined ? Object.values(JSON.parse(hosting_circle_pricing))[0] : '';
                    stepOneData.hosting_qa_pricing_30 = hosting_qa_pricing !== null && hosting_qa_pricing !== undefined ? Object.values(JSON.parse(hosting_qa_pricing))[0] : '';
                    stepOneData.comments = comments !== null && comments !== undefined ? comments : ""
                    stepOneData.coaching_info = coaching_info

                    stepOneData.payitforward_pricing_30= payitforward_pricing !== null && payitforward_pricing !== undefined ? Object.values(JSON.parse(payitforward_pricing))[0]
                    : "";
                    stepOneData.payitforward_pricing_45= payitforward_pricing !== null && payitforward_pricing !== undefined  ? Object.values(JSON.parse(payitforward_pricing))[1]
                    : "";
                    stepOneData.payitforward_pricing_60= payitforward_pricing !== null  && payitforward_pricing !== undefined ? Object.values(JSON.parse(payitforward_pricing))[2]
                    : "";
                    stepOneData.payitforward_pricing_45_2= payitforward_pricing !== null  && payitforward_pricing !== undefined ? Object.values(JSON.parse(payitforward_pricing))[3]
                    : "";
                    stepOneData.payitforward_pricing_60_2= payitforward_pricing !== null  && payitforward_pricing !== undefined ? Object.values(JSON.parse(payitforward_pricing))[4]
                    : "";
                    stepOneData.payitforward_coaching_pricing= payitforward_coaching_pricing !== null  && payitforward_coaching_pricing !== undefined ? payitforward_coaching_pricing
                    : "";
                    stepOneData.group_coaching = group_coaching !== null && group_coaching !== undefined ? group_coaching : 0;
                    stepOneData.coached_practice_circles = coached_practice_circles !== null && coached_practice_circles !== undefined ? coached_practice_circles : 0;
                    stepOneData.speaker_events = speaker_events !== null && speaker_events !== undefined ? speaker_events : 0;
                    stepOneData.demo_practice = demo_practice !== null && demo_practice !== undefined ? demo_practice : 0;
                    stepOneData.demo_professional = demo_professional !== null && demo_professional !== undefined ? demo_professional : 0;
                    
                    stepOneData.pay_forward = pay_forward !== null && pay_forward !== undefined ? pay_forward : 0;

                    
                    dispatch(setLoading(false))
                    setProfileSection(data.data.data);
                    setProfileLoaded(true);
                }
            })
            .catch((err) => {
                dispatch(setLoading(false))
                console.log(err)
            });
    }
  // Default form values
  const initialValues = {
    currency: "USD",
    sessionPrices: {
      "30 Minutes": "",
      "45 Minutes": "",
      "60 Minutes": "",
      "45 Minutes for 2 People": "",
      "60 Minutes for 2 People": "",
    },
    coachingPrices: {
      "30 Minutes": "",
      "60 Minutes": "",
      
    },
    groupPrices: {
      "Group Coaching": "",
      "Coached Practice Circles": "",
    },
  };
const handleSectionSubmit = (sectionName, values) => {
  const { currency, sessionPrices, coachingPrices, groupPrices, DemonstrationsPrices } = values;

  let item = {
    userId: pricingId,
  };
  if (sectionName === "payitforward") {
  const pf = values.PayItForwardPrices;
    
  const pfc = values.PayItForwardCoaching;

  const payload = {
    userId: pricingId,
    session_currency: JSON.stringify({
        30: currency,
        45: currency,
        60: currency,
        452: currency,
        602: currency,
      }),
    payitforward_pricing: JSON.stringify({
      30: pf["30 Minutes"] || "",
      45: pf["45 Minutes"] || "",
      60: pf["60 Minutes"] || "",
      452: pf["45 Minutes for 2 People"] || "",
      602: pf["60 Minutes for 2 People"] || "",
    }),
    payitforward_coaching_pricing: JSON.stringify(pfc),

  };

  console.log("➡️ Pay It Forward Payload:", payload);

  updatePricing(payload)
    .then((data) => {
      dispatch(setLoading(false));
      if (data.data.status) {
        toast.success("Pay It Forward Updated", {
          position: "top-center",
        });
      } else {
        toast.error(data.data.message);
      }
    })
    .catch((err) => {
      dispatch(setLoading(false));
      console.log(err);
      toast.error("Something went wrong");
    });

  return;
}
  if(sectionName==="group"){
    let errors = [];

const OPTIONAL_FIELD = "Speaker Events";

Object.entries(groupPrices).forEach(([key, value]) => {
  if (key === OPTIONAL_FIELD) return; // skip validation

  if (value === "" || value === null || isNaN(value) || Number(value) < 0) {
    errors.push(`${key} price is required.`);
  }
});

if (errors.length > 0) {
  errors.forEach(err => toast.error(err));
  return;
}
// If all valid → convert to array
const price_for_attendees = Object.entries(groupPrices).map(([key, value]) =>
  value === "" ? 0 : Number(value)
);

const groupcoaching = process.env.REACT_APP_COACHING_GROUP_SESSION_ID; 
    const payload = {
      medium_id:pricingId,
      session_type: [2,2,29],
      subsession_type: [Number(groupcoaching), 94,95],
      price_for_attendees: price_for_attendees
    };
     updateGroupPricing(payload)
        .then((data) => {
          dispatch(setLoading(false));
          if (data.data.status) {
            toast.success("Pricing Updated", { position: "top-center" });
            // if (typeof onProfileUpdate === 'function') {
            //   onProfileUpdate(); // Call the parent function
            // } else {
            //   console.error('onProfileUpdate is not a function');
            // }
          }else{
            toast.error(data.data.message);
          }
        })
        .catch((err) => {
          dispatch(setLoading(false));
          toast.error(err);
        });
    console.log("➡️ Converted Group Prices:", payload);
    // item = {
    //   ...item,
    //   group_coaching_pricing:
    //     (groupPrices["Group Coaching"] === "" &&
    //       groupPrices["Coached Practice Circles"] === "")
    //       ? null
    //       : JSON.stringify({
    //           30: groupPrices["Group Coaching"],
    //           60: groupPrices["Coached Practice Circles"],
    //         }),
    // };  
    return;
  }
   if(sectionName==="Demo"){
    let errors = [];

const OPTIONAL_FIELD = "Practice Demo";
const OPTIONAL_FIELD2 = "Professional Demonstrations";

Object.entries(DemonstrationsPrices).forEach(([key, value]) => {
  if (key === OPTIONAL_FIELD || key === OPTIONAL_FIELD2) return; // skip validation

  if (value === "" || value === null || isNaN(value) || Number(value) < 0) {
    errors.push(`${key} price is required.`);
  }
});

if (errors.length > 0) {
  errors.forEach(err => toast.error(err));
  return;
}
// If all valid → convert to array
const price_for_attendees = Object.entries(DemonstrationsPrices).map(([key, value]) =>
  value === "" ? 0 : Number(value)
);
    const payload = {
      medium_id:pricingId,
      session_type: [33,35],
      subsession_type: [99,101],
      price_for_attendees: price_for_attendees
    };
     updateGroupPricing(payload)
        .then((data) => {
          dispatch(setLoading(false));
          if (data.data.status) {
            toast.success("Pricing Updated", { position: "top-center" });
            // if (typeof onProfileUpdate === 'function') {
            //   onProfileUpdate(); // Call the parent function
            // } else {
            //   console.error('onProfileUpdate is not a function');
            // }
          }else{
            toast.error(data.data.message);
          }
        })
        .catch((err) => {
          dispatch(setLoading(false));
          console.log(err);
        toast.error("Something went wrong");
        });
    console.log("➡️ Converted Group Prices:", payload);
    // item = {
    //   ...item,
    //   group_coaching_pricing:
    //     (groupPrices["Group Coaching"] === "" &&
    //       groupPrices["Coached Practice Circles"] === "")
    //       ? null
    //       : JSON.stringify({
    //           30: groupPrices["Group Coaching"],
    //           60: groupPrices["Coached Practice Circles"],
    //         }),
    // };  
    return;
  }

  // 🔹 Case 1: Currency section
  if (sectionName === "currency") {
    item = {
      ...item,
      session_length: JSON.stringify({
        30: sessionPrices["30 Minutes"],
        45: sessionPrices["45 Minutes"],
        60: sessionPrices["60 Minutes"],
        452: sessionPrices["45 Minutes for 2 People"],
        602: sessionPrices["60 Minutes for 2 People"],
      }),
      session_currency: JSON.stringify({
        30: currency,
        45: currency,
        60: currency,
        452: currency,
        602: currency,
      }),
      coaching_pricing:
        (coachingPrices["30 Minutes"] === "" ||
          coachingPrices["60 Minutes"] === "" ||
          (parseInt(coachingPrices["30 Minutes"]) === 0 &&
            parseInt(coachingPrices["60 Minutes"]) === 0)) &&
        coachingPrices["Group Coaching"] === "" &&
        coachingPrices["Coached Practice Circles"] === ""
          ? null
          : JSON.stringify({
              30: coachingPrices["30 Minutes"],
              60: coachingPrices["60 Minutes"],
            }),
    };
  }

  // 🔹 Case 2: Professional Client Sessions
  if (sectionName === "professional") {
    item = {
      ...item,
      session_length: JSON.stringify({
        30: sessionPrices["30 Minutes"],
        45: sessionPrices["45 Minutes"],
        60: sessionPrices["60 Minutes"],
        452: sessionPrices["45 Minutes for 2 People"],
        602: sessionPrices["60 Minutes for 2 People"],
      }),
      session_currency: JSON.stringify({
        30: currency,
        45: currency,
        60: currency,
        452: currency,
        602: currency,
      }),
    };
  }

  // 🔹 Case 3: Coaching Sessions Pricing
  if (sectionName === "coaching") {
    item = {
      ...item,
      session_currency: JSON.stringify({
        30: currency,
        45: currency,
        60: currency,
        452: currency,
        602: currency,
      }),
      coaching_pricing:
        (coachingPrices["30 Minutes"] === "" ||
          coachingPrices["60 Minutes"] === "" ||
          (parseInt(coachingPrices["30 Minutes"]) === 0 &&
            parseInt(coachingPrices["60 Minutes"]) === 0)) &&
        coachingPrices["Group Coaching"] === "" &&
        coachingPrices["Coached Practice Circles"] === ""
          ? null
          : JSON.stringify({
              30: coachingPrices["30 Minutes"],
              60: coachingPrices["60 Minutes"],
            }),
    };
  }
  if (sectionName === "extra") {
    const extra_services_data = {};

  stepOneData.extra_services_list.forEach(item => {
    const val = values.ExtraServicesPricing[item.name]; // FIXED

    extra_services_data[item.id] = val === "" ? "" : String(Number(val));
  });

    item = {
      ...item,
      session_currency: JSON.stringify({
        30: currency,
        45: currency,
        60: currency,
        452: currency,
        602: currency,
      }),
      extra_services_data: extra_services_data
    };
  }

  console.log("➡️ API Payload for", sectionName, ":", item);
 updatePricing(item)
        .then((data) => {
          dispatch(setLoading(false));
          if (data.data.status) {
            toast.success("Pricing Updated", { position: "top-center" });
            // if (typeof onProfileUpdate === 'function') {
            //   onProfileUpdate(); // Call the parent function
            // } else {
            //   console.error('onProfileUpdate is not a function');
            // }
          }
        })
        .catch((err) => {
          dispatch(setLoading(false));
          console.log(err);
          toast.error("Something went wrong");
        });
  // Example API call
  // updatePricing(item)
  //   .then(() => toast.success(`${sectionName} updated successfully!`))
  //   .catch(() => toast.error("Something went wrong"));
};
 let emptyCoaching = {};

if (stepOneData && stepOneData.coaching_info && Array.isArray(stepOneData.coaching_info)) {
  stepOneData.coaching_info.forEach((c) => {
    emptyCoaching[c.id] = "";
  });
}

  return (
    <>
    <h4 className="mb-4 fw-semibold text-dark">Session Settings</h4>
    {/* Payment Options */}
    <div className="d-flex flex-wrap gap-3 mb-4">
     {stepOneData && stepOneData.is_paypal_integrated && <button className="btn px-4 mgl-2">PayPal</button>}
     {stepOneData && stepOneData.is_stripe_integrated && <button className="btn px-4 mgl-2">Stripe</button>}
     {stepOneData && stepOneData.is_square_integrated && <button className="btn px-4 mgl-2">Square</button>}
      {stepOneData && stepOneData.pay_forward == 1 && <button className="btn px-4 mgl-2 green-col">Pay It Forward</button>}
    </div>
    <Formik
  enableReinitialize // 👈 very important!
  
  initialValues={{
  currency: stepOneData && stepOneData.session_currency
    ? stepOneData.session_currency
    : "USD",

  sessionPrices: {
    "30 Minutes": stepOneData && stepOneData.session_length_30 ? stepOneData.session_length_30 : "",
    "45 Minutes": stepOneData && stepOneData.session_length_45 ? stepOneData.session_length_45 : "",
    "60 Minutes": stepOneData && stepOneData.session_length_60 ? stepOneData.session_length_60 : "",
    "45 Minutes for 2 People": stepOneData && stepOneData.session_length_45_2 ? stepOneData.session_length_45_2 : "",
    "60 Minutes for 2 People": stepOneData && stepOneData.session_length_60_2 ? stepOneData.session_length_60_2 : "",
  },

  coachingPrices: {
    "30 Minutes": stepOneData && stepOneData.coaching_pricing_30 ? stepOneData.coaching_pricing_30 : "",
    "60 Minutes": stepOneData && stepOneData.coaching_pricing_60 ? stepOneData.coaching_pricing_60 : "",
  },
  groupPrices: {
    "Group Coaching": stepOneData && stepOneData.group_coaching ? stepOneData.group_coaching : 0,
    "Coached Practice Circles": stepOneData && stepOneData.coached_practice_circles ? stepOneData.coached_practice_circles : 0,
    "Speaker Events": stepOneData && stepOneData.speaker_events ? stepOneData.speaker_events : 0,
  },
  DemonstrationsPrices: {
    "Practice Demo": stepOneData && stepOneData.demo_practice ? stepOneData.demo_practice : 0,
    "Professional Demonstrations": stepOneData && stepOneData.demo_professional ? stepOneData.demo_professional : 0,
    
  },
  PayItForwardPrices: {
  "30 Minutes": stepOneData.payitforward_pricing_30 || "",
  "45 Minutes": stepOneData.payitforward_pricing_45 || "",
  "60 Minutes": stepOneData.payitforward_pricing_60 || "",
  "45 Minutes for 2 People": stepOneData.payitforward_pricing_45_2 || "",
  "60 Minutes for 2 People": stepOneData.payitforward_pricing_60_2 || "",
},
PayItForwardCoaching:
          stepOneData.payitforward_coaching_pricing
            ? {
                ...emptyCoaching,
                ...JSON.parse(stepOneData.payitforward_coaching_pricing),
              }
            : emptyCoaching,
    

 ExtraServicesPricing:
  stepOneData && stepOneData.extra_services_list
    ? stepOneData.extra_services_list.reduce((acc, item) => {
        acc[item.name] =
          item.amount !== null && item.amount !== undefined ? item.amount : "";
        return acc;
      }, {})
    : {},
}}
  onSubmit={(values) => {
    console.log("Formik form values:", values);
    //handleSubmit(values);
    // call your save API here
  }}
>
  {({ values }) => (
    <Form>
      <div className="border rounded shadow-sm bg-white">

        {/* ====================  TAB 1 ==================== */}
        <AccordionItem
          title="Session Currency"
          isOpen={open === 1}
          onToggle={() => toggle(1)}
        >
          
          <div className="d-flex gap-4 mb-3">
            <div className="currency-selector d-flex gap-3 mb-3 mt-2">
              {["USD", "CAD", "AUD", "EUR"].map((currency) => (
                <label key={currency} className="currency-option">
                  <Field
                    type="radio"
                    name="currency"
                    value={currency}
                  />
                  <span>{currency}</span>
                </label>
              ))}
            </div>
          </div>
          <button type="submit" className="btn btn-vs px-4" onClick={() => handleSectionSubmit("currency", values)}>
            Save
          </button>
        </AccordionItem>

        {/* ====================  TAB 2 ==================== */}
        <AccordionItem
          title="Professional Client Sessions"
          isOpen={open === 2}
          onToggle={() => toggle(2)}
        >
           <p className="red mt-4">
          Note: Pricing may be adjusted on this pricing page or within each service schedule and applies to all payment methods, including Pay It Forward.
        </p>
          <div className="row d-flex-unset">
            {Object.keys(values.sessionPrices).map((label) => (
              <div className="col-md-6 margin-top-10" key={label}>
                <label className="form-label fw-medium small">{label}</label>
                <Field
                  type="text"
                  name={`sessionPrices.${label}`}
                  className="form-control"
                  placeholder="Enter price"
                />
              </div>
            ))}
          </div>
          <div className="text-end mt-3">
            <button type="submit" className="btn btn-vs px-4" onClick={() => handleSectionSubmit("professional", values)}>
              Save
            </button>
          </div>
        </AccordionItem>

        {/* ====================  TAB 3 ==================== */}
        <AccordionItem
          title="1-on-1 Coaching Sessions Pricing"
          isOpen={open === 3}
          onToggle={() => toggle(3)}
        >
           <p className="red mt-4">
          Note: Pricing may be adjusted on this pricing page or within each service schedule and applies to all payment methods, including Pay It Forward.
        </p>
          <div className="row d-flex-unset g-3">
            {Object.keys(values.coachingPrices).map((label) => (
              <div className="col-md-6 margin-top-10" key={label}>
                <label className="form-label fw-medium small">{label}</label>
                <Field
                  type="text"
                  name={`coachingPrices.${label}`}
                  className="form-control"
                  placeholder="Enter price"
                />
              </div>
            ))}
          </div>
          <div className="text-end">
            <button type="submit" className="btn btn-vs px-4 mt-2" onClick={() => handleSectionSubmit("coaching", values)}>
              Save
            </button>
          </div>
        </AccordionItem>
         <AccordionItem
          title="Extra Services Pricing"
          isOpen={open === 4}
          onToggle={() => toggle(4)}
        >
           <p className="red mt-4">
            Note: Pricing may be adjusted on this pricing page or within each service schedule and applies to all payment methods, including Pay It Forward.
          </p>
          
          <div className="row d-flex-unset g-3">
            {Object.keys(values.ExtraServicesPricing).map((label) => (
              <div className="col-md-6 margin-top-10" key={label}>
                <label className="form-label fw-medium small">{label}</label>
                <Field
                  type="text"
                  name={`ExtraServicesPricing.${label}`}
                  className="form-control"
                  placeholder="Enter price"
                />
              </div>
            ))}
          </div>
          <div className="text-end">
            <button type="submit" className="btn btn-vs px-4 mt-2" onClick={() => handleSectionSubmit("extra", values)}>
              Save
            </button>
          </div>
        </AccordionItem>
          <AccordionItem
          title="Group Sessions Pricing"
          isOpen={open === 5}
          onToggle={() => toggle(5)}
        >
             <p className="red mt-4">
    Note: Pricing may be adjusted on this pricing page or within each service schedule and applies to all payment methods, including Pay It Forward.
  </p>
          <div className="row d-flex-unset g-3">
            {Object.keys(values.groupPrices).map((label) => (
              <div className="col-md-6 margin-top-10" key={label}>
                <label className="form-label fw-medium small">{label == "Group Coaching" ? "Group Coaching (TBD)" : label}</label>
                <Field
                  type="text"
                  name={`groupPrices.${label}`}
                  className="form-control"
                  placeholder="Enter price"
                />
              </div>
            ))}
          </div>
          <div className="text-end">
            <button type="submit" className="btn btn-vs px-4 mt-2" onClick={() => handleSectionSubmit("group", values)}>
              Save
            </button>
          </div>
        </AccordionItem>

         <AccordionItem
          title="Demonstrations Sessions Pricing"
          isOpen={open === 6}
          onToggle={() => toggle(6)}
        >
          <p className="red mt-4">
    Note: Pricing may be adjusted on this pricing page or within each service schedule and applies to all payment methods, including Pay It Forward.
  </p>
          <div className="row d-flex-unset g-3">
            {Object.keys(values.DemonstrationsPrices).map((label) => (
              <div className="col-md-6 margin-top-10" key={label}>
                <label className="form-label fw-medium small">{label}</label>
                <Field
                  type="text"
                  name={`DemonstrationsPrices.${label}`}
                  className="form-control"
                  placeholder="Enter price"
                />
              </div>
            ))}
          </div>
          <div className="text-end">
            <button type="submit" className="btn btn-vs px-4 mt-2" onClick={() => handleSectionSubmit("Demo", values)}>
              Save
            </button>
          </div>
        </AccordionItem>
        {/* <AccordionItem
  title="Pay It Forward Suggested Amount"
  isOpen={open === 7}
  onToggle={() => toggle(7)}

>
  <p className="red mt-4">
    Note: Pay It Forward uses the prices defined in the Group Prices and Demonstration Prices sections.
  </p>

    <h6 className="fw-bold mt-4 mb-2">Professional Client Sessions
 </h6>
  <div className="row d-flex-unset g-3">
    {Object.keys(values.PayItForwardPrices).map((label) => (
      <div className="col-md-6 margin-top-10" key={label}>
        <label className="form-label fw-medium small">{label}</label>
        <Field
          type="text"
          name={`PayItForwardPrices.${label}`}
          className="form-control"
          placeholder="Enter price"
        />
      </div>
    ))}
  </div>

  <h6 className="fw-bold mt-4 mb-2">Coaching Sessions Pricing </h6>

 <div className="row d-flex-unset g-3">
   {stepOneData &&
    stepOneData.coaching_info &&
    Array.isArray(stepOneData.coaching_info) &&
    stepOneData.coaching_info
      .filter(
        (item) =>
          item.sub_session_name !== "Group Coaching" &&
          item.sub_session_name !== "Coached Practice Circles"
      )
      .map((item) => (
        <div className="col-md-6 margin-top-10" key={item.id}>
          <label className="form-label fw-medium small">
            {item.sub_session_name}
          </label>

          <Field
            type="text"
            name={`PayItForwardCoaching.${item.id}`}
            className="form-control"
            placeholder="Enter price"
          />
        </div>
      ))}
</div>


  <div className="text-end mt-3">
    <button
      type="submit"
      className="btn btn-vs px-4"
      onClick={() => handleSectionSubmit("payitforward", values)}
    >
      Save
    </button>
  </div>
</AccordionItem> */}
        

      </div>
    </Form>
  )}
</Formik>
 </>
  );
}

const AccordionItem = ({ title, children, isOpen, onToggle }) => (
  <div className="border-bottom">
    <div
      className="d-flex justify-content-between align-items-center p-3 bg-light"
      style={{ cursor: "pointer" }}
      onClick={onToggle}
    >
      <h6 className="mb-0 fw-semibold text-dark">{title}</h6>
      <span
        className="toggle-icon fw-bold"
        style={{
          fontSize: "1.3rem",
          color: "#d5a67b",
          transition: "all 0.3s ease",
        }}
      >
        {isOpen ? "−" : "+"}
      </span>
    </div>
    {isOpen && <div className="px-4 pb-4">{children}</div>}
  </div>
);
